import { ISaveUserRoles, IUserRoles, queryKeys } from '../../shared';
import { userRoleClient } from '../clients/user-role.client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IResponseMessages } from '../../shared/models/response-messages.model';

const client = userRoleClient;
const key = queryKeys.USER_ROLES;

export function useSaveUserRole() {
    const queryClient = useQueryClient();
    return useMutation<IUserRoles, AxiosError, { data: ISaveUserRoles; messages: IResponseMessages }>({
        mutationFn: ({ data, messages }) =>
            data?.id ? client.updateOne(data.id, data, messages) : client.createOne(data, messages),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [key] });
            await queryClient.invalidateQueries({ queryKey: [queryKeys.AuthRoles] });
        },
    });
}

export function useDeleteUserRole() {
    const queryClient = useQueryClient();
    return useMutation<void, AxiosError, { id: string; messages: IResponseMessages }>({
        mutationFn: ({ id, messages }) => client.deleteOne(id, messages),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [key] });
            await queryClient.invalidateQueries({ queryKey: [queryKeys.AuthRoles] });
        },
    });
}
